// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 60 60" {...rest} unit={unit}>
		<title>Uncertain</title>
		<g>
			<circle id="Oval" fill="#D3C609" cx="30" cy="30" r="30"></circle>
			<path d="M26.2819315,35.4376945 C26.2601246,31.5342678 27.0015576,29.0482865 
				29.3566978,27.0856697 C31.2975078,25.5373831 32.5623053,24.1199376 
				32.5623053,22.6152647 C32.5623053,20.6090342 31.711838,19.8457943 
				30.0545171,19.8457943 C28.8333333,19.8457943 27.5031153,20.6308411 
				27.4376947,22.9205607 L19.5,22.9205607 C19.6090343,16.2040498 24.1448598,13.5 
				30.0545171,13.5 C36.5529595,13.5 40.5,16.4439252 40.5,22.2227414 
				C40.5,25.995327 37.9922118,27.8707164 35.135514,30.5093457 C33.5436137,31.9704049 
				33.1074766,33.1697818 33.0420561,35.4376945 L26.2819315,35.4376945 Z 
				M29.7492213,45.9704053 C27.3504674,45.9704053 25.4314642,44.0514023 
				25.4314642,41.6526485 C25.4314642,39.2757016 27.3504674,37.3566985 
				29.7492213,37.3566985 C32.1479753,37.3566985 34.0669785,39.2757016 
				34.0669785,41.6526485 C34.0669785,44.0514023 32.1479753,45.9704053 
				29.7492213,45.9704053 Z" id="?" fill="#FFFFFF" fillRule="nonzero"></path>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Uncertain.js